export const CONTACT_EMAIL = 'placeyourjob@placeyourjob.com';
